import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "au-navigable",
  ref: "container"
}
const _hoisted_2 = { class: "au-navigable__title" }
const _hoisted_3 = { class: "au-navigable__header-info" }
const _hoisted_4 = { class: "au-navigable__left" }
const _hoisted_5 = { class: "au-navigable__center" }
const _hoisted_6 = { class: "au-navigable__right" }

import { computed, ref, onBeforeUnmount } from 'vue';
    import { useModule } from 'src/modules/modules';
    import { adEvents } from 'util/ad-util';
    import { AdMobBannerSize } from '@capacitor-community/admob';
    import { deviceEvents } from 'util/device-util';

    //const emit = defineEmits(['back', 'next']);
    
export default /*#__PURE__*/_defineComponent({
  __name: 'navigable-screen',
  props: {
    useBannerOffset: { type: Boolean }
  },
  emits: ['native-back'],
  setup(__props: any, { emit }) {

const props = __props as {
        useBannerOffset?: boolean
    }

    const { global } = useModule();
    const headerEl = ref<HTMLDivElement>();
    const navEl = ref<HTMLDivElement>();
    
    

    /**
     * Handle banner resize, get the height
     */
    const bannerHeight = ref<number>(50);
    const handleBannerResize = (size: AdMobBannerSize) => bannerHeight.value = size.height
    adEvents.on('bannerSizeChange', handleBannerResize)
    onBeforeUnmount(() => adEvents.removeListener('bannerSizeChange', handleBannerResize));

    const bannerAdjustedHeight = computed(() => {
        if (global.platform !== 'web' && props.useBannerOffset){
            let headerHeight =  /* titleEl.value?.getBoundingClientRect().height ?? */ 75;
            let navHeight = /* navEl.value?.getBoundingClientRect().height ?? */ 115;
            return {
                height: `calc(100% - ${bannerHeight.value + headerHeight + navHeight}px)`
            }
        }
    })

    const handleHardwareBackBtn = () => emit('native-back');
    deviceEvents.on('backButton', handleHardwareBackBtn);
    onBeforeUnmount(() => {
        deviceEvents.removeListener('backButton', handleHardwareBackBtn);
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "au-navigable__header",
      ref_key: "headerEl",
      ref: headerEl
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header-info")
      ])
    ], 512),
    _createElementVNode("div", {
      class: "au-navigable__content",
      style: _normalizeStyle(_unref(bannerAdjustedHeight))
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 4),
    _createElementVNode("div", {
      class: "au-navigable__nav",
      ref_key: "navEl",
      ref: navEl
    }, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "nav-left")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "nav-center")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "nav-right")
      ])
    ], 512)
  ], 512))
}
}

})